import React, { FC }                from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Icon }             from "semantic-ui-react";
import RegisterCustomerRecord       from "../../../../application/usecase/record/customer/RegisterCustomerRecord";
import CustomerId                   from "../../../../domain/customer/CustomerId";
import CustomerRecord               from "../../../../domain/record/customer/CustomerRecord";
import { ResKaState }               from "../../../../index";

const CustomerRecordRegisterButton: FC = () => {
  const customerId: CustomerId = useSelector((state: ResKaState) => state.customer.id);
  const customerRecord: CustomerRecord = useSelector((state: ResKaState) => state.customerRecord);
  const registerCustomerRecord: RegisterCustomerRecord = new RegisterCustomerRecord(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"
        positive
        onClick={ () => registerCustomerRecord.execute(customerId, customerRecord) }
      >
        <Icon name="save"/>
        保存する
      </Button>
    </>
  );
};

export default CustomerRecordRegisterButton;
